webpackJsonp([1],[
/* 0 */,
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_js_vuex_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_index__ = __webpack_require__(41);







var Utils = function () {
    function Utils() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Utils);

        this.setTime = null;
        this.time = 500;
        this.music = ['http://ws.stream.qqmusic.qq.com/107192078.m4a?fromtag=46', 'http://ws.stream.qqmusic.qq.com/410316.m4a?fromtag=46', 'http://ws.stream.qqmusic.qq.com/101091484.m4a?fromtag=46', 'http://ws.stream.qqmusic.qq.com/97758.m4a?fromtag=46', 'http://ws.stream.qqmusic.qq.com/97750.m4a?fromtag=46'];
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Utils, [{
        key: 'isNull',
        value: function isNull(str) {
            if (str === "") return true;
            var regu = "^[ ]+$";
            var re = new RegExp(regu);
            return re.test(str);
        }
    }, {
        key: 'removeDuplicated',
        value: function removeDuplicated(ar) {
            var tmp = {};
            var ret = [];
            for (var i = 0, j = ar.length; i < j; i++) {
                var item = ar[i].song_id;
                if (!tmp[item]) {
                    tmp[item] = 1;
                    ret.push(ar[i]);
                }
            }
            return ret;
        }
    }, {
        key: 'prev',
        value: function prev() {
            if (JSON.parse(sessionStorage.otherWebsites)) {
                __WEBPACK_IMPORTED_MODULE_5__router_index__["a" /* default */].push('/music');
                console.log('回首页');
                return;
            }
            console.log('回上一页');
            __WEBPACK_IMPORTED_MODULE_5__router_index__["a" /* default */].go(-1);
        }
    }, {
        key: 'getStorage',
        value: function getStorage(name) {
            var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '[]';

            var n = localStorage.getItem(name);
            if (!n || n === '') {
                localStorage.setItem(name, defaults);
                n = localStorage.getItem(name);
            }
            return JSON.parse(n);
        }
    }, {
        key: 'lately',
        value: function lately(song) {
            var latelyList = this.getStorage('lately');
            if (!song) {
                return latelyList;
            }

            latelyList.unshift(song);

            latelyList = this.removeDuplicated(latelyList);
            if (latelyList.length > 100) {
                latelyList.length = 100;
            }

            localStorage.lately = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(latelyList);

            __WEBPACK_IMPORTED_MODULE_4__common_js_vuex_js__["a" /* default */].commit('setLatelyLength', latelyList.length);
        }
    }, {
        key: 'searchIndex',
        value: function searchIndex() {
            var indexs = '';
            var songId = __WEBPACK_IMPORTED_MODULE_4__common_js_vuex_js__["a" /* default */].state.songId;
            __WEBPACK_IMPORTED_MODULE_4__common_js_vuex_js__["a" /* default */].state.playList.forEach(function (item, index) {
                if (item.song_id === songId) {
                    localStorage.songPrevIndex = localStorage.songIndex;
                    localStorage.songIndex = index;
                    indexs = index;
                }
            });
            return indexs;
        }
    }, {
        key: 'playList',
        value: function playList(type, data) {
            var playList = this.getStorage('playList');

            switch (type) {
                case 1:
                    playList = data;
                    break;
                case 2:
                    var yes = this.searchIndex();
                    var index = this.getStorage('songIndex', 0);

                    if (yes === '') {
                        playList.splice(index + 1, 0, data);
                        if (JSON.parse(localStorage.playList).length) {
                            localStorage.songIndex = index + 1;
                        }
                    } else {}
                    break;
                default:
                    return;
            }
            __WEBPACK_IMPORTED_MODULE_4__common_js_vuex_js__["a" /* default */].commit('setPlayList', playList);
            localStorage.playList = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(playList);
            return playList;
        }
    }, {
        key: 'getPlay',
        value: function getPlay(id, callback) {
            var _this = this;

            clearTimeout(this.setTime);
            this.setTime = setTimeout(function () {
                __WEBPACK_IMPORTED_MODULE_4__common_js_vuex_js__["a" /* default */].dispatch('getFileLink', id).then(function (res) {
                    var data = res.body.songinfo;
                    var currentSong = {
                        file_link: res.body.bitrate.file_link,

                        album_title: data.album_title,
                        author: data.author,
                        title: data.title,
                        song_id: data.song_id,
                        pic_big: data.pic_big,
                        pic_small: data.pic_small,
                        pic_radio: data.pic_radio,
                        lrclink: data.lrclink
                    };
                    __WEBPACK_IMPORTED_MODULE_4__common_js_vuex_js__["a" /* default */].commit('setSong', currentSong);
                    __WEBPACK_IMPORTED_MODULE_4__common_js_vuex_js__["a" /* default */].commit('setPlayState', { state: true });
                    localStorage.current_song = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(currentSong);
                    _this.lately(currentSong);
                    _this.setTime = null;
                    callback && callback();
                }).catch(function (e) {
                    __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].prototype.$alert('点太快了哦');
                });
            }, this.time);
        }
    }, {
        key: 'getSong',
        value: function getSong(song) {
            var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;
            var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

            var id = song.song_id || song.songid;
            if (__WEBPACK_IMPORTED_MODULE_4__common_js_vuex_js__["a" /* default */].state.songId === id) {
                __WEBPACK_IMPORTED_MODULE_4__common_js_vuex_js__["a" /* default */].commit('setPlayState', { state: !__WEBPACK_IMPORTED_MODULE_4__common_js_vuex_js__["a" /* default */].state.playState });
                return false;
            }

            __WEBPACK_IMPORTED_MODULE_4__common_js_vuex_js__["a" /* default */].commit('setSongId', id);
            if (song.song_id && song.title && song.pic_small) {
                var currentSong = {
                    file_link: null,
                    album_title: song.album_title,
                    author: song.author,
                    title: song.title,
                    song_id: song.song_id,
                    pic_big: song.pic_big,
                    pic_small: song.pic_small,
                    pic_radio: song.pic_radio,
                    lrclink: song.lrclink
                };
                __WEBPACK_IMPORTED_MODULE_4__common_js_vuex_js__["a" /* default */].commit('setSong', currentSong);
            }
            console.log(__WEBPACK_IMPORTED_MODULE_4__common_js_vuex_js__["a" /* default */].state.playState);
            __WEBPACK_IMPORTED_MODULE_4__common_js_vuex_js__["a" /* default */].state.playState && document.getElementById('audio').pause();
            this.playList(type, data);
            this.searchIndex();
            this.getPlay(id);
        }
    }, {
        key: 'songChange',
        value: function songChange() {
            var _this2 = this;

            var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

            clearTimeout(this.clearTime);
            this.clearTime = setTimeout(function () {
                var playList = __WEBPACK_IMPORTED_MODULE_4__common_js_vuex_js__["a" /* default */].state.playList;

                var index = parseInt(localStorage.songIndex);
                if (_this2.getStorage('currentMode') === 1) {
                    var random = Math.floor(Math.random() * playList.length);
                    index = random;

                    if (parseInt(localStorage.songIndex) === random) {
                        index++;
                        if (index >= playList.length) {
                            index = 0;
                        }
                    }
                } else {
                    if (type === 1) {
                        index = index + 1;
                        if (index >= playList.length) {
                            index = 0;
                        }
                    } else if (type === -1) {
                        index = !index ? playList.length - 1 : index - 1;
                    }
                }
                console.log(index);
                _this2.setTime = null;
                _this2.getSong(__WEBPACK_IMPORTED_MODULE_4__common_js_vuex_js__["a" /* default */].state.playList[index]);
            }, this.time);
        }
    }]);

    return Utils;
}();

/* harmony default export */ __webpack_exports__["a"] = (new Utils());

/***/ }),
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(148)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(79),
  /* template */
  __webpack_require__(195),
  /* scopeId */
  "data-v-239e8629",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]());

/***/ }),
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);


var serve = {
    url: 'http://tingapi.ting.baidu.com/v1/restserver/ting',
    get: function get(option) {
        return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.jsonp(this.url, {
            params: option
        });
    }
};

/* harmony default export */ __webpack_exports__["a"] = (serve);

/***/ }),
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(150)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(72),
  /* template */
  __webpack_require__(197),
  /* scopeId */
  "data-v-2b5e987a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(147)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(81),
  /* template */
  __webpack_require__(194),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(164)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(77),
  /* template */
  __webpack_require__(211),
  /* scopeId */
  "data-v-90a7756e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 39 */,
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_resource__ = __webpack_require__(43);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_resource__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */].Store({
  state: {
    song: {},

    songId: Number,

    playState: false,

    timePercentage: 0,

    night: localStorage.night ? JSON.parse(localStorage.night) : false,

    latelyLength: localStorage.lately && JSON.parse(localStorage.lately).length,

    playListToggle: false,
    playList: [],

    loveList: [],

    currentMode: 0
  },
  mutations: {
    setSong: function setSong(state, data) {
      state.song = data;
    },
    setPlayState: function setPlayState(state, data) {
      state.playState = data.state;
    },
    setCurrentTime: function setCurrentTime(state, time) {
      if (!time.duration) {
        return;
      }
      state.timePercentage = time.currentTime / time.duration * 100;
    },
    nightToggle: function nightToggle(state) {
      state.night = !state.night;
    },
    setLatelyLength: function setLatelyLength(state, length) {
      state.latelyLength = length;
    },
    setSongId: function setSongId(state, id) {
      state.songId = id;
    },
    playListToggle: function playListToggle(state, val) {
      state.playListToggle = val;
    },
    setPlayList: function setPlayList(state, data) {
      state.playList = data;
    },
    setLoveList: function setLoveList(state, data) {
      state.loveList = data;
    },
    setCurrentMode: function setCurrentMode(state, mode) {
      state.currentMode = mode;
    }
  },

  actions: {
    getFileLink: function getFileLink(_ref, id) {
      var commit = _ref.commit;

      return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.jsonp('http://tingapi.ting.baidu.com/v1/restserver/ting?method=baidu.ting.song.play', {
        params: {
          songid: id
        }
      });
    }
  }
}));

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__view_music__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__view_music___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__view_music__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__view_search_search__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__view_search_search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__view_search_search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__view_lately_lately__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__view_lately_lately___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__view_lately_lately__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__view_ranking__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__view_ranking___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__view_ranking__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__view_toplist__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__view_toplist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__view_toplist__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__view_artist__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__view_artist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__view_artist__);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  linkActiveClass: 'on',
  routes: [{ name: 'music', path: '/music', component: __WEBPACK_IMPORTED_MODULE_2__view_music___default.a }, { name: 'search', path: '/search', component: __WEBPACK_IMPORTED_MODULE_3__view_search_search___default.a }, { name: 'lately', path: '/lately', component: __WEBPACK_IMPORTED_MODULE_4__view_lately_lately___default.a }, {
    name: 'ranking',
    path: '/ranking',
    component: __WEBPACK_IMPORTED_MODULE_5__view_ranking___default.a,
    children: [{ name: 'toplist', path: ':type', component: __WEBPACK_IMPORTED_MODULE_6__view_toplist___default.a }]
  }, {
    name: 'artist',
    path: '/artist',
    component: __WEBPACK_IMPORTED_MODULE_7__view_artist___default.a
  }, { path: '/*', redirect: '/music' }]
}));

/***/ }),
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(149)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(74),
  /* template */
  __webpack_require__(196),
  /* scopeId */
  "data-v-2a7c352e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_webpack_zepto__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_webpack_zepto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_webpack_zepto__);



/* harmony default export */ __webpack_exports__["a"] = ({
    install: function install() {
        var timer = null;
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$alert = function (msg) {
            __WEBPACK_IMPORTED_MODULE_1_webpack_zepto___default()('#alertWeek').remove();
            var $alert = __WEBPACK_IMPORTED_MODULE_1_webpack_zepto___default()('<div class="week-alert" id="alertWeek"></div>');
            __WEBPACK_IMPORTED_MODULE_1_webpack_zepto___default()('body').append($alert);
            $alert.html(msg);
            $alert.addClass('alert-show');
            clearTimeout(timer);
            timer = setTimeout(function () {
                $alert.remove();
            }, 2000);
        };
    }
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return focus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);

var focus = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].directive('focus', {
    inserted: function inserted(el) {
        el.focus();
    }
});


/***/ }),
/* 62 */
/***/ (function(module, exports) {


exports.secToTime = function (s) {
  var t = '';
  if (s > -1) {
    var min = Math.floor(s / 60) % 60;

    var sec = s % 60;

    if (min < 10) {
      t += "0";
    }
    t += min + ":";

    if (sec < 10) {
      t += "0";
    }

    t += Math.round(sec);
  }
  return t;
};

/***/ }),
/* 63 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(152)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(66),
  /* template */
  __webpack_require__(199),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__filter__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__directive__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_js_vuex_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_resource__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_js_alert_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_scss_index_scss__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_scss_index_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__common_scss_index_scss__);







console.log(__WEBPACK_IMPORTED_MODULE_5__directive__["a" /* focus */]);




__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_resource__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8__common_js_alert_js__["a" /* default */]);
var abortAjxa = [];
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.interceptors.push(function (request, next) {
  request.params.format = 'json';
  request.params.from = 'webapp_music';

  if (request.url === 'http://tingapi.ting.baidu.com/v1/restserver/ting?method=baidu.ting.song.play') {
    abortAjxa.forEach(function (item, index) {
      item.abort();
      abortAjxa.splice(index, 1);
    });
    abortAjxa.push(request);
  }
  next();
});

__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_4__filter___default.a).forEach(function (k) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].filter(k, __WEBPACK_IMPORTED_MODULE_4__filter___default.a[k]);
});

__WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].beforeEach(function (to, from, next) {
  if (from.path === '/') {
    sessionStorage.otherWebsites = true;
    console.log('从其他网站跳进来的');
  } else {
    sessionStorage.otherWebsites && (sessionStorage.otherWebsites = false);
  }
  next();
});

new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_6__common_js_vuex_js__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a }
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_play_play__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_play_play___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_play_play__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__view_home__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__view_home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__view_home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])({
    night: function night(state) {
      return state.night;
    }
  })),
  components: {
    Play: __WEBPACK_IMPORTED_MODULE_1__components_play_play___default.a,
    home: __WEBPACK_IMPORTED_MODULE_2__view_home___default.a
  }
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__serve__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loading_loading__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loading_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__loading_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__songList_songList__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__songList_songList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__songList_songList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_js_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(2);








/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'sheet',
    props: {
        scroll: ''
    },
    data: function data() {
        return {
            sheet: {
                'love': {
                    show: true,
                    title: '猜你喜欢',
                    length: '',
                    loading: true,
                    items: []
                },
                'loveSong': {
                    show: false,
                    title: '我喜欢的音乐',
                    length: '',
                    loading: false,
                    items: []
                }
            }
        };
    },
    created: function created() {
        var _this = this;

        var lately = localStorage.loveList && JSON.parse(localStorage.loveList);
        var songId = void 0;
        if (lately && lately.length) {
            songId = lately[Math.floor(Math.random() * lately.length)].song_id;
        } else {
            songId = 7994;
        }
        this.$store.commit('setLoveList', __WEBPACK_IMPORTED_MODULE_4__common_js_utils__["a" /* default */].getStorage('loveList'));

        var option = {
            method: 'baidu.ting.song.getRecommandSongList',
            song_id: songId,
            num: 100
        };
        __WEBPACK_IMPORTED_MODULE_1__serve__["a" /* default */].get(option).then(function (res) {
            _this.sheet.love.items = res.body.result.list;
            _this.sheet.love.length = res.body.result.list.length;
            _this.sheet.love.loading = false;
            setTimeout(function () {
                _this.scroll.refresh();
            }, 20);
        });
    },

    methods: {
        eventShow: function eventShow(sheetItem) {
            var _this2 = this;

            sheetItem.show = !sheetItem.show;
            setTimeout(function () {
                _this2.scroll.refresh();
            }, 20);
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])({
        loveList: function loveList(state) {
            return state.loveList;
        }
    })),
    watch: {
        loveList: function loveList(_loveList) {
            this.sheet.loveSong.items = _loveList;
            this.sheet.loveSong.length = _loveList.length;
        }
    },
    components: {
        loading: __WEBPACK_IMPORTED_MODULE_2__loading_loading___default.a,
        songlist: __WEBPACK_IMPORTED_MODULE_3__songList_songList___default.a
    }
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_js_bus__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'usersub',
    data: function data() {
        return {
            items: [{
                text: '最近播放',
                number: '100',
                icon: '&#xe612;'
            }, {
                text: '下载管理',
                number: '6',
                icon: '&#xe6a5;'
            }, {
                text: '我的歌手',
                number: '2',
                icon: '&#xe619;'
            }]
        };
    },

    methods: {
        latelyShow: function latelyShow() {
            __WEBPACK_IMPORTED_MODULE_1__common_js_bus__["a" /* default */].$emit('latelyShow');
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])({
        latelyLength: function latelyLength(state) {
            return state.latelyLength;
        }
    }))
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        play: {
            type: Boolean,
            default: false
        },
        songDetail: {
            type: Object,
            default: function _default() {
                return {};
            }
        }
    }
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'controller',
    props: {
        song: {
            type: Object,
            default: function _default() {
                return {};
            }
        },
        playState: {
            type: Boolean,
            default: false
        }
    },
    created: function created() {
        if (localStorage.current_song) {
            var currentSong = JSON.parse(localStorage.current_song);
            this.$store.commit('setSong', currentSong);
            this.$store.commit('setSongId', currentSong.song_id);
        }
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])({
        progress: function progress(state) {
            var percent = state.timePercentage / 100;
            var perimeter = Math.PI * 2 * 14;
            var dasharray = perimeter * percent + " " + perimeter * (1 - percent);
            return dasharray;
        }
    })),
    methods: {
        playGo: function playGo() {
            var audio = document.getElementById('audio');
            if (audio.readyState === 0 && !this.$store.state.playState) {
                return;
            }

            this.$store.commit('setPlayState', { state: !this.$store.state.playState });
        },
        songShow: function songShow() {
            this.$emit('songShow');
        },
        playList: function playList() {
            this.$store.commit('playListToggle', true);
        }
    }
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_js_bus__ = __webpack_require__(12);



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'MyHeader',
    data: function data() {
        return {
            nav: [{
                path: '/ranking',
                icon: '&#xe661;'
            }, {
                path: '/music',
                icon: '&#xe655;'
            }],
            nToggle: this.$store.state.night
        };
    },

    methods: {
        search: function search() {
            __WEBPACK_IMPORTED_MODULE_0__common_js_bus__["a" /* default */].$emit('toggle');
        },
        nightToggle: function nightToggle() {
            this.$store.commit('nightToggle');
            this.nToggle = this.$store.state.night;
            localStorage.night = this.nToggle;
        }
    }
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    }
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__scroll_scroll__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__scroll_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__scroll_scroll__);



/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        error: {
            type: Boolean,
            default: false
        },
        lrc: {
            type: Object,
            default: function _default() {
                return {};
            }
        },
        offset: {
            type: Number,
            default: 0
        },
        currentTime: {
            type: Number,
            default: 0
        },
        show: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        offset: function offset() {
            this.$refs.scrolls.scrollTo(0, -this.offset, 500);
        },
        show: function show(_show) {
            var _this = this;

            if (_show) {
                setTimeout(function () {
                    _this.$refs.scrolls.refresh();
                }, 25);
            }
        }
    },
    components: {
        scroll: __WEBPACK_IMPORTED_MODULE_0__scroll_scroll___default.a
    }
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_js_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        title: {
            type: Boolean,
            default: false
        },
        size: {
            default: '25'
        }
    },
    data: function data() {
        return {
            currentMode: __WEBPACK_IMPORTED_MODULE_1__common_js_utils__["a" /* default */].getStorage('currentMode', 0)
        };
    },
    created: function created() {
        this.$store.commit('setCurrentMode', this.currentMode);
    },

    methods: {
        changeMode: function changeMode() {
            if (this.currentMode === 2) {
                this.currentMode = 0;
            } else {
                this.currentMode = this.currentMode + 1;
            }
            localStorage.currentMode = this.currentMode;
            this.$store.commit('setCurrentMode', this.currentMode);
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])({
        setCurrentMode: function setCurrentMode(state) {
            return state.currentMode;
        }
    }))
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scroll_scroll__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scroll_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__scroll_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_mode_mode__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_mode_mode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_mode_mode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_js_utils_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);







/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            items: []
        };
    },
    created: function created() {
        this.$store.commit('setPlayList', localStorage.playList && JSON.parse(localStorage.playList) || []);
    },

    methods: {
        hide: function hide() {
            this.$store.commit('playListToggle', false);
        },
        fileLink: function fileLink(id) {
            __WEBPACK_IMPORTED_MODULE_3__common_js_utils_js__["a" /* default */].getSong(id);
        },
        clear: function clear() {
            localStorage.removeItem('current_song');
            localStorage.removeItem('playList');
            localStorage.removeItem('songIndex');
            localStorage.removeItem('songPrevIndex');
            this.$store.commit('setSong', {});
            this.$store.commit('setSongId', Number);
            this.$store.commit('setPlayState', { state: false });
            this.$store.commit('setPlayList', []);
            this.$store.commit('playListToggle', false);
        },
        __autoScroll: function __autoScroll(time) {
            var _this = this;

            setTimeout(function () {
                var currentHeight = 35 * (parseInt(localStorage.songIndex) + 1);
                var playListH = _this.$refs.playList.offsetHeight;
                if (currentHeight >= playListH / 1.5) {
                    _this.$refs.scroll.scrollTo(0, -(currentHeight - playListH / 2), time);
                } else {
                    _this.$refs.scroll.scrollTo(0, 0, time);
                }
            }, 20);
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])({
        playListToggle: function playListToggle(state) {
            if (state.playListToggle) {
                this.__autoScroll(0);
            }
            return state.playListToggle;
        },
        setPlayLis: function setPlayLis(state) {
            return state.playList;
        },
        songId: function songId(state) {
            return state.songId;
        }
    })),
    watch: {
        playListToggle: function playListToggle() {
            var _this2 = this;

            setTimeout(function () {
                _this2.$refs.scroll.refresh();
            }, 20);
        },
        setPlayLis: function setPlayLis(list) {
            this.items = list;
        }
    },
    components: {
        scroll: __WEBPACK_IMPORTED_MODULE_1__scroll_scroll___default.a,
        mode: __WEBPACK_IMPORTED_MODULE_2__components_mode_mode___default.a
    }
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_js_bus__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_js_utils__ = __webpack_require__(1);






/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'play',
    data: function data() {
        return {
            file_link: './static/res/xpg/小苹果.mp3',
            audio: ''
        };
    },
    mounted: function mounted() {
        var _this = this;

        this.$nextTick(function () {
            _this.audio = document.getElementById('audio');
            _this.audio.load();

            _this.audio.addEventListener('ended', function () {
                switch (parseInt(localStorage.currentMode)) {
                    case 0:
                        __WEBPACK_IMPORTED_MODULE_3__common_js_utils__["a" /* default */].songChange(1);
                        break;
                    case 1:
                        __WEBPACK_IMPORTED_MODULE_3__common_js_utils__["a" /* default */].songChange();
                        break;
                    case 2:
                        _this.audio.currentTime = 0;
                        _this.audio.play();
                }
            }, false);

            _this.audio.addEventListener('timeupdate', function () {
                _this.$store.commit('setCurrentTime', {
                    duration: _this.audio.duration, currentTime: _this.audio.currentTime
                });

                __WEBPACK_IMPORTED_MODULE_2__common_js_bus__["a" /* default */].$emit('timeupdate', _this.audio.currentTime);
            }, false);
            _this.audio.addEventListener('durationchange', function () {
                __WEBPACK_IMPORTED_MODULE_2__common_js_bus__["a" /* default */].$emit('getDuration', _this.audio.duration);
            });

            _this.audio.addEventListener('canplay', function () {
                console.log('可以播放');
                _this.$store.state.playState && _this.audio.play();
            }, false);
        });
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])({
        song: function song(state) {
            return state.song;
        },
        playState: function playState(state) {
            return state.playState;
        }
    })),
    watch: {
        song: function song(_song, oldVal) {
            var _this2 = this;

            setTimeout(function () {
                _this2.audio.load();
            }, 20);
        },
        playState: function playState(_playState, oldVal) {
            if (this.audio.readyState === 0) {
                return;
            }
            _playState ? this.audio.play() : this.audio.pause();
        }
    }
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_js_utils__ = __webpack_require__(1);



/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        title: {
            type: String,
            default: ''
        },
        styleOpacity: {
            type: String,
            default: 'default'
        }
    },
    methods: {
        prev: function prev() {
            __WEBPACK_IMPORTED_MODULE_0__common_js_utils__["a" /* default */].prev();
        }
    },
    computed: {
        opacity: function opacity() {
            return 'head' + this.styleOpacity;
        }
    }
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_js_bus__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            timeupdate: '',
            time: '',
            progressLength: true
        };
    },
    created: function created() {
        var _this = this;

        this.$nextTick(function () {
            __WEBPACK_IMPORTED_MODULE_1__common_js_bus__["a" /* default */].$on('getDuration', function (s) {
                _this.time = parseInt(s);
            });
            __WEBPACK_IMPORTED_MODULE_1__common_js_bus__["a" /* default */].$on('timeupdate', function (s) {
                _this.progressLength && (_this.timeupdate = parseInt(s));
            });
            _this.audio = document.getElementById('audio');
            _this.barWrapper = _this.$refs.barWrapper;
            _this.bar = _this.$refs.bar;

            _this.audio.addEventListener('canplay', function () {
                _this.progressLength = true;
            }, false);

            _this.barWrapper.addEventListener('touchstart', function (e) {
                _this.__touchBar(e);
                _this.progressLength = false;
            });

            _this.barWrapper.addEventListener('touchmove', function (e) {
                e.preventDefault();
                _this.__touchBar(e);
            });

            _this.barWrapper.addEventListener('touchend', function (e) {
                _this.audio.currentTime = _this.timeupdate;
            });
        });
    },

    methods: {
        __touchBar: function __touchBar(e) {
            !this.barOffsetLeft && (this.barOffsetLeft = this.barWrapper.offsetLeft);
            !this.barOffsetWidth && (this.barOffsetWidth = this.barWrapper.offsetWidth);
            var percentage = (e.touches[0].pageX - this.barOffsetLeft) / this.barOffsetWidth;
            percentage = percentage < 0 ? 0 : percentage > 1 ? 1 : percentage;
            this.bar.style.width = percentage * 100 + '%';
            this.timeupdate = parseInt(this.audio.duration * percentage);
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])({
        progress: function progress(state) {
            if (this.progressLength) {
                return state.timePercentage;
            }
        }
    }))
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_better_scroll__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_better_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_better_scroll__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'scroll',
  props: {
    probeType: {
      type: Number,
      default: 1
    },

    click: {
      type: Boolean,
      default: true
    },

    scrollX: {
      type: Boolean,
      default: false
    },

    listenScroll: {
      type: Boolean,
      default: false
    },

    data: {
      default: null
    },

    pullup: {
      type: Boolean,
      default: false
    },

    pulldown: {
      type: Boolean,
      default: false
    },

    beforeScroll: {
      type: Boolean,
      default: false
    },

    refreshDelay: {
      type: Number,
      default: 20
    }
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      _this._initScroll();
    }, 20);
  },

  methods: {
    _initScroll: function _initScroll() {
      var _this2 = this;

      if (!this.$refs.wrapper) {
        return;
      }

      this.scroll = new __WEBPACK_IMPORTED_MODULE_0_better_scroll___default.a(this.$refs.wrapper, {
        probeType: this.probeType,
        click: this.click,
        scrollX: this.scrollX
      });

      if (this.listenScroll) {
        var me = this;
        this.scroll.on('scroll', function (pos) {
          me.$emit('scroll', pos);
        });
      }

      if (this.pullup) {
        this.scroll.on('scrollEnd', function () {
          if (_this2.scroll.y <= _this2.scroll.maxScrollY + 50) {
            _this2.$emit('scrollToEnd');
          }
        });
      }

      if (this.pulldown) {
        this.scroll.on('touchend', function (pos) {
          if (pos.y > 50) {
            _this2.$emit('pulldown');
          }
        });
      }

      if (this.beforeScroll) {
        this.scroll.on('beforeScrollStart', function () {
          _this2.$emit('beforeScroll');
        });
      }
    },
    disable: function disable() {
      this.scroll && this.scroll.disable();
    },
    enable: function enable() {
      this.scroll && this.scroll.enable();
    },
    refresh: function refresh() {
      this.scroll && this.scroll.refresh();
    },
    scrollTo: function scrollTo() {
      this.scroll && this.scroll.scrollTo.apply(this.scroll, arguments);
    },
    scrollToElement: function scrollToElement() {
      this.scroll && this.scroll.scrollToElement.apply(this.scroll, arguments);
    }
  },
  watch: {
    data: function data() {
      var _this3 = this;

      setTimeout(function () {
        _this3.refresh();
      }, this.refreshDelay);
    }
  }
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_js_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_mode_mode__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_mode_mode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_mode_mode__);





/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        play: {
            type: Boolean,
            default: false
        },
        song: {
            type: Object,
            default: function _default() {
                return {};
            }
        }
    },
    data: function data() {
        return {
            clearTime: 0,
            love: false
        };
    },

    methods: {
        playGo: function playGo() {
            this.$store.commit('setPlayState', { state: !this.$store.state.playState });
        },
        songChange: function songChange() {
            var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

            __WEBPACK_IMPORTED_MODULE_1__common_js_utils__["a" /* default */].songChange(type);
        },
        loveFn: function loveFn() {
            var _this = this;

            var loveList = __WEBPACK_IMPORTED_MODULE_1__common_js_utils__["a" /* default */].getStorage('loveList');
            if (!this.love) {
                loveList.unshift(this.song);
                this.love = true;
                this.$alert('添加到喜欢');
            } else {
                loveList.forEach(function (item, index) {
                    if (item.song_id === _this.song.song_id) {
                        _this.love = false;
                        loveList.splice(index, 1);
                        _this.$alert('取消喜欢');
                    }
                });
            }
            this.$store.commit('setLoveList', loveList);
            localStorage.loveList = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(loveList);
        }
    },
    watch: {
        song: function song(_song) {
            var loveList = __WEBPACK_IMPORTED_MODULE_1__common_js_utils__["a" /* default */].getStorage('loveList');
            for (var i = 0; i < loveList.length; i++) {
                if (loveList[i].song_id === this.song.song_id) {
                    this.love = true;
                    return;
                } else {
                    this.love = false;
                }
            }
        }
    },
    components: {
        mode: __WEBPACK_IMPORTED_MODULE_2__components_mode_mode___default.a
    }
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_js_utils_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        songs: {
            type: Array,
            default: function _default() {
                return [];
            }
        },
        styles: {
            type: Number,
            default: 1
        }
    },
    methods: {
        fileLink: function fileLink(id, type, data) {
            __WEBPACK_IMPORTED_MODULE_1__common_js_utils_js__["a" /* default */].getSong(id, type, data);
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])({
        songId: function songId(state) {
            return state.songId;
        }
    }))
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__serve__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scroll_scroll__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scroll_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__scroll_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_js_bus__ = __webpack_require__(12);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            toplist: []
        };
    },
    created: function created() {
        var _this = this;

        this.getTopList(1).then(function () {
            return _this.getTopList(2);
        }).then(function () {
            return _this.getTopList(11);
        }).then(function () {
            return _this.getTopList(12);
        }).then(function () {
            return _this.getTopList(16);
        }).then(function () {
            return _this.getTopList(21);
        }).then(function () {
            return _this.getTopList(22);
        }).then(function () {
            return _this.getTopList(23);
        }).then(function () {
            return _this.getTopList(24);
        }).then(function () {
            _this.$emit('loadHide');
            _this.getTopList(25);
        });
        __WEBPACK_IMPORTED_MODULE_2__common_js_bus__["a" /* default */].$on('resetScroll', function () {
            _this.$refs.scroll.refresh();
        });
    },

    methods: {
        getTopList: function getTopList(types) {
            var _this2 = this;

            var option = {
                method: 'baidu.ting.billboard.billList',
                type: types,
                size: 3,
                offset: 0
            };
            return __WEBPACK_IMPORTED_MODULE_0__serve__["a" /* default */].get(option).then(function (res) {
                _this2.toplist.push({
                    icon: res.data.billboard.pic_s210,
                    item: res.data.song_list,
                    path: types
                });
            });
        }
    },
    components: {
        scroll: __WEBPACK_IMPORTED_MODULE_1__scroll_scroll___default.a
    }
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_js_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_scroll_scroll__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_scroll_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_scroll_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__serve__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_prevheader_prevheader__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_prevheader_prevheader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_prevheader_prevheader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_loading_loading__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_loading_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_loading_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_songList_songList__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_songList_songList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_songList_songList__);









/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      artist: null,

      type: 1,

      hto: 1,

      singerInfo: 2,

      album: 3,

      probeType: 3,

      nav: true,

      notSong: [],

      avatarDetail: null,

      collectionSwitch: false
    };
  },
  activated: function activated() {
    var _this = this;

    if (!this.$route.params.artist) {
      this.$router.push({ path: '/' });
      return;
    }

    this.artist = this.$route.params.artist;
    setTimeout(function () {
      _this.avatar = _this.$refs.avatar;
      _this.scroll = _this.$refs.scroll;
    }, 20);

    this.switchTab(this.type);
    this.myArtist = __WEBPACK_IMPORTED_MODULE_1__common_js_utils__["a" /* default */].getStorage('artist');
    this.collectionSwitch = this.checkRepeat(this.myArtist, this.artist);
  },
  deactivated: function deactivated() {
    this.$destroy();
  },

  methods: {
    __scroll: function __scroll(pos) {
      var scale = 1;
      if (pos.y > 1) {
        scale += (pos.y - 1) / 200;
        this.avatar.style.WebkitTransform = 'scale(' + (scale < 1 ? 1 : scale) + ') translate3d(0, ' + (pos.y - 1) / 4 + 'px, 0)';
        this.$refs.headerBg.style.opacity = 0;
      } else {
        this.avatar.style.WebkitTransform = 'scale(' + 1 + ') translate3d(0, ' + (pos.y > -80 ? pos.y : -80) + 'px, 0)';
        var headerBg = pos.y / (-160 / 0.7);
        this.$refs.headerBg.style.opacity = headerBg > 0.7 ? 0.7 : headerBg.toFixed(2);
        var operation = 160 + pos.y;
        this.$refs.operation.style.opacity = operation / 100 > 1 ? 1 : operation / 100 < 0 ? 0 : operation / 100;
        if (pos.y <= -160) {
          this.nav = false;
        } else {
          this.nav = true;
        }
      }
    },
    artistSong: function artistSong(id) {
      var _this2 = this;

      var option = {
        method: 'baidu.ting.artist.getSongList',
        tinguid: id,
        use_cluster: '1',
        order: '2'
      };
      __WEBPACK_IMPORTED_MODULE_3__serve__["a" /* default */].get(option).then(function (res) {
        _this2.notSong = res.data.songlist;
        setTimeout(function () {
          _this2.scroll.refresh();
        }, 20);
      });
    },
    getAvatarDetail: function getAvatarDetail(id) {
      var _this3 = this;

      var option = {
        method: 'baidu.ting.artist.getinfo',
        tinguid: id
      };
      __WEBPACK_IMPORTED_MODULE_3__serve__["a" /* default */].get(option).then(function (res) {
        _this3.avatarDetail = res.data.intro.split('\n');
        setTimeout(function () {
          _this3.scroll.refresh();
        }, 20);
      });
    },
    switchTab: function switchTab(type) {
      var _this4 = this;

      this.type = type;
      switch (type) {
        case 1:
          if (!this.notSong.length) {
            this.artistSong(this.artist.ting_uid);
          }
          break;
        case 2:
          if (!this.avatarDetail) {
            this.getAvatarDetail(this.artist.ting_uid);
          }
          break;
        case 3:
      }
      if (this.scroll) {
        setTimeout(function () {
          _this4.scroll.refresh();
        });
      }
    },
    checkRepeat: function checkRepeat(myArtist, artist, indexSwitch) {
      var repeat = false;
      var index = void 0;
      for (var i = 0; i < myArtist.length; i++) {
        if (myArtist[i].ting_uid === artist.ting_uid) {
          repeat = true;
          index = i;
          break;
        } else {
          repeat = false;
        }
      }
      return indexSwitch ? index : repeat;
    },
    collection: function collection(artist) {
      if (!this.checkRepeat(this.myArtist, artist)) {
        this.myArtist.push(artist);
        this.collectionSwitch = true;
        localStorage.artist = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.myArtist);
      } else {
        var index = this.checkRepeat(this.myArtist, artist, true);
        this.myArtist.splice(index, 1);
        localStorage.artist = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.myArtist);
        this.collectionSwitch = false;
      }
    }
  },
  components: {
    Scroll: __WEBPACK_IMPORTED_MODULE_2__components_scroll_scroll___default.a,
    prevheader: __WEBPACK_IMPORTED_MODULE_4__components_prevheader_prevheader___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_5__components_loading_loading___default.a,
    songList: __WEBPACK_IMPORTED_MODULE_6__components_songList_songList___default.a
  }
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_header_header__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_header_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_header_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_controller_controller__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_controller_controller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_controller_controller__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__view_song__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__view_song___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__view_song__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_playList_playList__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_playList_playList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_playList_playList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(2);








/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      songShow: false
    };
  },
  created: function created() {
    var _this = this;

    this.$nextTick(function () {
      _this.$refs.controller.$on('songShow', function () {
        _this.songShow = true;
      });
      _this.$refs.song.$on('songHide', function () {
        _this.songShow = false;
      });
    });
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])({
    song: function song(state) {
      return state.song;
    },
    playState: function playState(state) {
      return state.playState;
    }
  })),
  components: {
    MyHeader: __WEBPACK_IMPORTED_MODULE_1__components_header_header___default.a,
    controller: __WEBPACK_IMPORTED_MODULE_2__components_controller_controller___default.a,
    song: __WEBPACK_IMPORTED_MODULE_3__view_song___default.a,
    playList: __WEBPACK_IMPORTED_MODULE_4__components_playList_playList___default.a
  }
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_scroll_scroll__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_scroll_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_scroll_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_songList_songList__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_songList_songList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_songList_songList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_prevheader_prevheader__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_prevheader_prevheader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_prevheader_prevheader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_js_utils__ = __webpack_require__(1);






/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            items: []
        };
    },
    created: function created() {
        this.items = __WEBPACK_IMPORTED_MODULE_3__common_js_utils__["a" /* default */].lately();
    },
    activated: function activated() {
        this.items = __WEBPACK_IMPORTED_MODULE_3__common_js_utils__["a" /* default */].lately();
    },

    components: {
        scroll: __WEBPACK_IMPORTED_MODULE_0__components_scroll_scroll___default.a,
        songlist: __WEBPACK_IMPORTED_MODULE_1__components_songList_songList___default.a,
        prevheader: __WEBPACK_IMPORTED_MODULE_2__components_prevheader_prevheader___default.a
    }
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Usersub_Usersub__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Usersub_Usersub___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Usersub_Usersub__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Sheet_Sheet__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Sheet_Sheet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Sheet_Sheet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_scroll_scroll__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_scroll_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_scroll_scroll__);






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      scrollComponent: ''
    };
  },
  created: function created() {
    var _this = this;

    this.$nextTick(function () {
      _this.scrollComponent = _this.$refs.scroll;
    });
  },
  activated: function activated() {},

  methods: {
    end: function end() {
      console.log('到底了');
    }
  },
  components: {
    Usersub: __WEBPACK_IMPORTED_MODULE_0__components_Usersub_Usersub___default.a,
    Sheet: __WEBPACK_IMPORTED_MODULE_1__components_Sheet_Sheet___default.a,
    Scroll: __WEBPACK_IMPORTED_MODULE_2__components_scroll_scroll___default.a
  }
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_toplist_toplist__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_toplist_toplist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_toplist_toplist__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_loading_loading__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_loading_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_loading_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_js_bus__ = __webpack_require__(12);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      load: true
    };
  },
  activated: function activated() {
    __WEBPACK_IMPORTED_MODULE_2__common_js_bus__["a" /* default */].$emit('resetScroll');
  },

  methods: {
    loadHide: function loadHide() {
      this.load = false;
    }
  },
  components: {
    toplist: __WEBPACK_IMPORTED_MODULE_0__components_toplist_toplist___default.a,
    loading: __WEBPACK_IMPORTED_MODULE_1__components_loading_loading___default.a
  }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_scroll_scroll__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_scroll_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_scroll_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_loading_loading__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_loading_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_loading_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_songList_songList__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_songList_songList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_songList_songList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__serve__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_js_utils_js__ = __webpack_require__(1);










/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'search',
    data: function data() {
        return {
            searchVal: null,

            page_no: 1,

            page_size: 50,

            songItems: [],

            artist: null,

            album: null,

            loadingShow: true,

            songMoreController: true,

            noMOre: false,
            searchLog: [],
            logController: true
        };
    },
    created: function created() {
        var _this = this;

        this.searchLog = localStorage.searchLog ? JSON.parse(localStorage.searchLog) : [];
        this.$nextTick(function () {
            _this.input = document.getElementById("your-input-id");

            _this.$refs.content.addEventListener('touchstart', function (e) {
                _this.input.blur();
            });
        });
    },

    methods: {
        search: function search() {
            if (__WEBPACK_IMPORTED_MODULE_7__common_js_utils_js__["a" /* default */].isNull(this.searchVal)) {
                return;
            }

            this.songItems.length && (this.songItems = []);
            this.artist && (this.artist = null);
            this.album && (this.album = null);
            this.page_no = 1;
            this.noMOre = false;

            this.loadingShow = true;
            this.logController = __WEBPACK_IMPORTED_MODULE_7__common_js_utils_js__["a" /* default */].isNull(this.searchVal);
            this.setSearchLog(this.searchVal);
            this.getSong(this.page_no, this.page_size, this.searchVal);
            this.time = false;
        },
        setSearchLog: function setSearchLog(log) {
            log = log.replace(/(^\s*)|(\s*$)/g, "");
            this.searchLog.unshift(log);

            this.searchLog = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default()(new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a(this.searchLog));
            localStorage.searchLog = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.searchLog);
        },
        getSong: function getSong(page, size, query) {
            var _this2 = this;

            this.songMoreController = false;
            var option = {
                method: 'baidu.ting.search.common',
                query: query,
                page_no: page,
                page_size: size
            };
            __WEBPACK_IMPORTED_MODULE_6__serve__["a" /* default */].get(option).then(function (res) {
                if (!_this2.artist && res.data.artist) {
                    _this2.artist = res.data.artist;
                }
                if (!_this2.album && res.data.album) {
                    _this2.album = res.data.album;
                }
                if (res.data.song_list) {
                    _this2.songItems = _this2.songItems.concat(res.data.song_list);
                    _this2.songMoreController = true;
                } else {
                    _this2.noMOre = true;
                }
                _this2.loadingShow = false;
            });
        },
        prev: function prev() {
            __WEBPACK_IMPORTED_MODULE_7__common_js_utils_js__["a" /* default */].prev();
        },
        clear: function clear() {
            this.songItems = [];
            this.searchVal = null;
            this.artist = null;
            this.album = null;
            this.loadingShow = false;
        },
        songLoadMore: function songLoadMore() {
            if (this.songMoreController) {
                this.page_no++;
                this.loadingShow = true;
                this.getSong(this.page_no, this.page_size, this.searchVal);
            }
        },
        logDelete: function logDelete(deletes) {
            this.searchLog.splice(this.searchLog.indexOf(deletes), 1);
            localStorage.searchLog = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.searchLog);
        }
    },
    watch: {
        searchVal: function searchVal(val, oldVal) {
            var _this3 = this;

            if (__WEBPACK_IMPORTED_MODULE_7__common_js_utils_js__["a" /* default */].isNull(val)) {
                this.songItems = [];
                this.artist = null;
                this.album = null;
                this.logController = true;
                setTimeout(function () {
                    __WEBPACK_IMPORTED_MODULE_7__common_js_utils_js__["a" /* default */].isNull(_this3.searchVal) && _this3.$refs.logScroll.refresh();
                }, 20);
            } else {
                this.time && clearTimeout(this.time);
                this.time = setTimeout(function () {
                    _this3.search();
                }, 300);
            }
        }
    },
    components: {
        Scroll: __WEBPACK_IMPORTED_MODULE_3__components_scroll_scroll___default.a,
        Loading: __WEBPACK_IMPORTED_MODULE_4__components_loading_loading___default.a,
        songList: __WEBPACK_IMPORTED_MODULE_5__components_songList_songList___default.a
    }
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_scroll_scroll__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_scroll_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_scroll_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_cd_cd__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_cd_cd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_cd_cd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_progress_progress__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_progress_progress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_progress_progress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_songController_songController__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_songController_songController___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_songController_songController__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_lrc_lrc__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_lrc_lrc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_lrc_lrc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_js_bus__ = __webpack_require__(12);









/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    show: {
      type: Boolean,
      default: false
    },
    song: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    playState: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      lrc: '',

      lrcParagraph: '',

      lrcOffset: 0,

      currentTime: 0,
      toggle: true
    };
  },
  created: function created() {
    var _this = this;

    setTimeout(function () {
      __WEBPACK_IMPORTED_MODULE_6__common_js_bus__["a" /* default */].$on('timeupdate', function (s) {
        if (_this.lrc.lrcMap[Math.round(s)]) {
          _this.lrcParagraph = _this.lrc.lrcMap[Math.round(s)];

          _this.lrcOffset = _this.lrc.offset[Math.round(s)];

          _this.currentTime = Math.round(s);
        }
      });
    }, 20);
    this.getLrc();
    this.$nextTick(function () {
      document.getElementById('audio').addEventListener('loadedmetadata', function () {
        _this.getLrc();
      }, false);
    });
  },

  methods: {
    prev: function prev() {
      var _this2 = this;

      this.$emit('songHide');
      setTimeout(function () {
        _this2.toggle = true;
      }, 300);
    },
    toggleFn: function toggleFn() {
      this.toggle = !this.toggle;
    },
    parseLyric: function parseLyric(lrc) {
      var lyrics = lrc.split("\n");
      var lrcObj = {
        offset: {},
        lrcMap: {}
      };
      for (var i = 0; i < lyrics.length; i++) {
        var lyric = decodeURIComponent(lyrics[i]);
        var timeReg = /\[\d*:\d*((\.|:)\d*)*\]/g;
        var timeRegExpArr = lyric.match(timeReg);
        if (!timeRegExpArr) continue;
        var clause = lyric.replace(timeReg, '');
        for (var k = 0, h = timeRegExpArr.length; k < h; k++) {
          var t = timeRegExpArr[k];
          var min = Number(String(t.match(/\[\d*/i)).slice(1));
          var sec = Number(String(t.match(/:\d*/i)).slice(1));
          var time = min * 60 + sec;

          lrcObj.lrcMap[time] = clause;
        }
      }
      var lrcMap = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(lrcObj.lrcMap);
      for (var _i = 0; _i < lrcMap.length; _i++) {
        lrcObj.offset[lrcMap[_i]] = 30 * _i;
      }
      return lrcObj;
    },
    getLrc: function getLrc() {
      var _this3 = this;

      this.$http.get(this.song.lrclink).then(function (lrc) {
        _this3.lrc = _this3.parseLyric(lrc.bodyText);
        _this3.lrcParagraph = _this3.song.title;
      });
    }
  },
  watch: {
    song: function song(_song) {
      this.lrcParagraph = '歌词加载中...';
      this.lrc.lrcMap && (this.lrc.lrcMap = {});
    }
  },
  components: {
    Scroll: __WEBPACK_IMPORTED_MODULE_1__components_scroll_scroll___default.a,
    cd: __WEBPACK_IMPORTED_MODULE_2__components_cd_cd___default.a,
    progressbar: __WEBPACK_IMPORTED_MODULE_3__components_progress_progress___default.a,
    songConteroller: __WEBPACK_IMPORTED_MODULE_4__components_songController_songController___default.a,
    lrc: __WEBPACK_IMPORTED_MODULE_5__components_lrc_lrc___default.a
  }
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_loading_loading__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_loading_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_loading_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_scroll_scroll__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_scroll_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_scroll_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__serve__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_js_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_prevheader_prevheader__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_prevheader_prevheader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_prevheader_prevheader__);







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      title: '排行榜',
      toplist: [],
      load: true,
      pullup: true,
      noneData: false
    };
  },
  created: function created() {
    var _this = this;

    switch (parseInt(this.$route.params.type)) {
      case 1:
        this.title = '新歌榜';
        break;
      case 2:
        this.title = '热歌榜';
        break;
      case 11:
        this.title = '摇滚榜';
        break;
      case 12:
        this.title = '爵士';
        break;
      case 16:
        this.title = '流行';
        break;
      case 21:
        this.title = '欧美金曲榜';
        break;
      case 22:
        this.title = '经典老歌榜';
        break;
      case 23:
        this.title = '情歌对唱榜';
        break;
      case 24:
        this.title = '影视金曲榜';
        break;
      case 25:
        this.title = '网络歌曲榜';
        break;
      default:
        __WEBPACK_IMPORTED_MODULE_3__common_js_utils__["a" /* default */].prev();
    }
    setTimeout(function () {
      _this.getData(50).then(function (res) {
        _this.load = false;
        _this.toplist = res.body.song_list;
      });
    }, 300);
  },

  methods: {
    getData: function getData() {
      var num = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 20;
      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.toplist.length;

      var option = {
        method: 'baidu.ting.billboard.billList',
        type: this.$route.params.type,
        size: num,
        offset: offset
      };
      return __WEBPACK_IMPORTED_MODULE_2__serve__["a" /* default */].get(option);
    },
    fileLink: function fileLink(id, type, data) {
      __WEBPACK_IMPORTED_MODULE_3__common_js_utils__["a" /* default */].getSong(id, type, data);
    },
    loadmore: function loadmore() {
      var _this2 = this;

      if (this.pullup) {
        this.pullup = false;
        this.getData().then(function (res) {
          if (!res.body.song_list || !res.body.song_list.length) {
            _this2.noneData = true;
            return;
          }
          _this2.toplist = _this2.toplist.concat(res.body.song_list);
          _this2.pullup = true;
        });
      }
    }
  },
  components: {
    prevheader: __WEBPACK_IMPORTED_MODULE_4__components_prevheader_prevheader___default.a,
    scroll: __WEBPACK_IMPORTED_MODULE_1__components_scroll_scroll___default.a,
    loading: __WEBPACK_IMPORTED_MODULE_0__components_loading_loading___default.a
  }
});

/***/ }),
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 146 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 147 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 148 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 149 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 150 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 151 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 152 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 153 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 154 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 155 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 156 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 157 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 158 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 159 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 160 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 161 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 162 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 163 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 164 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 165 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 166 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 167 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 168 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 169 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(167)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(67),
  /* template */
  __webpack_require__(214),
  /* scopeId */
  "data-v-beecba6e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(166)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(68),
  /* template */
  __webpack_require__(213),
  /* scopeId */
  "data-v-a2b77796",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(161)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(69),
  /* template */
  __webpack_require__(208),
  /* scopeId */
  "data-v-5ff060a9",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(162)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(70),
  /* template */
  __webpack_require__(209),
  /* scopeId */
  "data-v-6c267bc9",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(155)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(71),
  /* template */
  __webpack_require__(202),
  /* scopeId */
  "data-v-444863ae",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(156)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(73),
  /* template */
  __webpack_require__(203),
  /* scopeId */
  "data-v-48bb20f6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(159)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(75),
  /* template */
  __webpack_require__(206),
  /* scopeId */
  "data-v-5900b36e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(168)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(76),
  /* template */
  __webpack_require__(215),
  /* scopeId */
  "data-v-e99e2fee",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(154)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(78),
  /* template */
  __webpack_require__(201),
  /* scopeId */
  "data-v-43c208a9",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(157)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(80),
  /* template */
  __webpack_require__(204),
  /* scopeId */
  "data-v-50fa5fa9",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(153)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(82),
  /* template */
  __webpack_require__(200),
  /* scopeId */
  "data-v-4393e231",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(169)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(216),
  /* scopeId */
  "data-v-ea8b3aa4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(146)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(84),
  /* template */
  __webpack_require__(193),
  /* scopeId */
  "data-v-09ee97f4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(160)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(85),
  /* template */
  __webpack_require__(207),
  /* scopeId */
  "data-v-5d086178",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(145)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(86),
  /* template */
  __webpack_require__(192),
  /* scopeId */
  "data-v-01adf40e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(165)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(87),
  /* template */
  __webpack_require__(212),
  /* scopeId */
  "data-v-965f9d42",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(151)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(88),
  /* template */
  __webpack_require__(198),
  /* scopeId */
  "data-v-2f693850",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(163)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(89),
  /* template */
  __webpack_require__(210),
  /* scopeId */
  "data-v-7386a93c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(158)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(90),
  /* template */
  __webpack_require__(205),
  /* scopeId */
  "data-v-577183c8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 192 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "music-wrapper"
  }, [_c('scroll', {
    ref: "scroll",
    attrs: {
      "pullup": true
    },
    on: {
      "scrollToEnd": function($event) {
        _vm.end()
      }
    }
  }, [_c('ul', {
    staticClass: "music"
  }, [_c('usersub'), _vm._v(" "), _c('sheet', {
    ref: "sheet",
    attrs: {
      "scroll": _vm.scrollComponent
    }
  })], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 193 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('my-header'), _vm._v(" "), _c('keep-alive', [_c('router-view')], 1), _vm._v(" "), _c('controller', {
    ref: "controller",
    attrs: {
      "song": _vm.song,
      "playState": _vm.playState
    }
  }), _vm._v(" "), _c('song', {
    ref: "song",
    attrs: {
      "song": _vm.song,
      "playState": _vm.playState,
      "show": _vm.songShow
    }
  }), _vm._v(" "), _c('playList')], 1)
},staticRenderFns: []}

/***/ }),
/* 194 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [(_vm.styles === 1) ? _vm._l((_vm.songs), function(item) {
    return _c('li', {
      key: item.song_id,
      staticClass: "song-list",
      class: {
        active: _vm.songId === item.song_id
      },
      on: {
        "click": function($event) {
          _vm.fileLink(item, 1, _vm.songs)
        }
      }
    }, [(_vm.songId === item.song_id) ? _c('i', {
      staticClass: "iconfont active-icon"
    }, [_vm._v("")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "img"
    }, [_c('img', {
      attrs: {
        "src": item.pic_small ? item.pic_small : item.pic_big,
        "alt": "",
        "width": "52",
        "height": "52"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "item-text .border-1px"
    }, [_c('h3', {
      staticClass: "item-title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', [_vm._v("专辑：" + _vm._s(item.album_title))])])])
  }) : _vm._e(), _vm._v(" "), (_vm.styles === 2) ? _vm._l((_vm.songs), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "search-list",
      on: {
        "click": function($event) {
          _vm.fileLink(item, 2, item)
        }
      }
    }, [_c('div', {
      staticClass: "songname"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(item.title)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "album",
      domProps: {
        "innerHTML": _vm._s('-' + item.author)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "album",
      domProps: {
        "innerHTML": _vm._s(item.album_title)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "info",
      domProps: {
        "innerHTML": _vm._s(item.info)
      }
    })])
  }) : _vm._e(), _vm._v(" "), (_vm.styles === 3) ? _vm._l((_vm.songs), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "search-list",
      on: {
        "click": function($event) {
          _vm.fileLink(item, 1, _vm.songs)
        }
      }
    }, [_c('div', {
      staticClass: "songname"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(item.title)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "album",
      domProps: {
        "innerHTML": _vm._s('-' + item.author)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "album",
      domProps: {
        "innerHTML": _vm._s(item.album_title)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "info",
      domProps: {
        "innerHTML": _vm._s(item.info)
      }
    })])
  }) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 195 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "wrapper",
    staticClass: "better-scroll"
  }, [_vm._t("default", [_vm._v("当前列表为空")])], 2)
},staticRenderFns: []}

/***/ }),
/* 196 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mode",
    on: {
      "click": function($event) {
        _vm.changeMode()
      }
    }
  }, [_c('span', [_c('i', {
    staticClass: "iconfont",
    style: ({
      fontSize: _vm.size + 'px'
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.setCurrentMode === 0 ? '&#xe65f;' : _vm.setCurrentMode === 1 ? '&#xe628;' : '&#xe78a;')
    }
  }), _vm._v(" "), (_vm.title) ? _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.setCurrentMode === 0 ? '列表循环' : _vm.setCurrentMode === 1 ? '随机播放' : '单曲循环'))]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 197 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading"
  }, [_c('img', {
    attrs: {
      "width": "24",
      "height": "24",
      "src": "data:image/gif;base64,R0lGODlhZABkAKIEAN7e3rq6uv///5mZmQAAAAAAAAAAAAAAACH/C05FVFNDQVBFMi4wAwEAAAAh/wtYTVAgRGF0YVhNUDw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDpBRjA4RUZDMDI3MjA2ODExODA4M0Y1OTQyMzVDRDM3MyIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpCMzE0Rjk3NDdDRTgxMUUzOUJCRjk0NjAxMUE1NzRBMCIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpCMzE0Rjk3MzdDRTgxMUUzOUJCRjk0NjAxMUE1NzRBMCIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ1M2IChNYWNpbnRvc2gpIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6RDVBMTZDQjczOTIwNjgxMTgwODNGNTk0MjM1Q0QzNzMiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6QUYwOEVGQzAyNzIwNjgxMTgwODNGNTk0MjM1Q0QzNzMiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz4B//79/Pv6+fj39vX08/Lx8O/u7ezr6uno5+bl5OPi4eDf3t3c29rZ2NfW1dTT0tHQz87NzMvKycjHxsXEw8LBwL++vby7urm4t7a1tLOysbCvrq2sq6qpqKempaSjoqGgn56dnJuamZiXlpWUk5KRkI+OjYyLiomIh4aFhIOCgYB/fn18e3p5eHd2dXRzcnFwb25tbGtqaWhnZmVkY2JhYF9eXVxbWllYV1ZVVFNSUVBPTk1MS0pJSEdGRURDQkFAPz49PDs6OTg3NjU0MzIxMC8uLSwrKikoJyYlJCMiISAfHh0cGxoZGBcWFRQTEhEQDw4NDAsKCQgHBgUEAwIBAAAh+QQFAAAEACwAAAAAZABkAAAD/0i63P4wykmrvTjrzbv/YCiOZGme6CasbOqObPvOXRzTeGbLeT/tK18KQLwABZeBUlghOgGVY0VJHTAlT2cUOK0ur4+s9sedeKngsBhK3lHO3zRjXZRIJfC4fEFv28xwew50bBB3EHlWgg2EEYcOiYtqYo5lD3mSk5QPjwyRmYNrhpYNmKChog6dCp+njKkNqwSmrq+wDG6QtD4BvRiNsX+lu296Hb3IARd9qjyegRZnH8nUTbfR0IDZG9TdFJsa0trEGd3eE08eVcWJihzm5ovt6x7w8WDz9CD25z35aCT4Vcvxz9gIgchwFJyBUOG8HvwckqNhT6K4K/1oXJST0P8HwFogQ4ocSbKkyVoFP8pJaRARS31MXsJ0KdNdzJo2L+FsqXFnzmE7r/j8CVRmmqDjXh7F2UXpSqMno0qdSrWq1ZNENWby4m/mzY0uJvYUa6JdV7NjW4XNZ1Ft2X9nH5ZIKYSuiIX44ILAu5StOr8RvGIQ/EwuB8OBuW4Aq9NtBseNCbOTXJjx4G14MDdVPJny5qyROS9gDJkmzxkTLZM95ZhcaVCQU6+WJ1v17D2lxb4WRLa3Zkmvff/mPZxV8VnH8x5fvfur5cqem3tMjvw5dJW4qd++HRe7ac/GRWcX/9176NNCwYcn//3qevXuz6OPn9g6/czw7xedrz9x//8KAAYo4IAEFthAAgAh+QQFAAAEACwLAAUAPwAjAAADxUi63P4QyAmrvfhNmrvP2/aNJBNyZdqdkvoFsMcCnmCTcB6AbGb/gpcuhpn5gLfOMFfsXZA/z5JoMT6hQeV0V3VWsEnt8mL9YkdbbsT7AGeF00rZ4U5t5ewGWJVenyB1fHEaeQt7Ln0Oc4aHiIMNiwqNjo8mIW2TCwObcGOQl3qZCpukA1KVCyJ0Zw6lrhl3I6IErrUYniRQELW2FzouQBW8vC7FDcPExsrIvcouzK/OxdCk0sbU1svI2drJ3NfR387V4hgJACH5BAUAAAQALBoABQA/ACMAAAPFSLrcHjC6Sau9L0LMu1ea9o0kE0pl6p2b6g3wynpATcL4wLEBV/+ATw63m2GAv9cwduEdkbbOkmlxXqBRzpRKsVawWe20afxiR1tdxTsBB9HbddnhTsW78wZYlcafKHV8YxNsDHsufRl/dIeIgw2FCo2OjyYhbZOUS4oohpkXAqEVd5CdnlAeoaoCFKQ0Zxirsq1DKaigsrO0XCRAsbm6LsIKwMDDwsXGxynJucsqzcHPI9Gq09DR1y7N2sjF3cPO4MfWHQkAIfkEBQAABAAsLgAFADEAMAAAA71Is0z+MMpJJ2s1a33v/qDTYWFJjYupSugQBvAKtR9sB7KI1ncs05qeLQfMCH2rIuWIVCknzJxiV2HiiFRoVPqEbLnZiFWqGy2P5HJHi053CV/3WjJOq1Pi+AbAz3jobR98gwAyehSEiYY9e4mKi02Ijo92kpOUlRCXk5kRm46dnp+EoZqjfaWmn6kSq6ytl6+Wg7IZtLW4ubq7vL2dAsDBwsPApcTHyL/Iy8GZzM/FdtDPztPHytbDodnCDgkAIfkEBQAABAAsOwAKACQAPwAAA69IujzOMMpJnB0062u1h1z3jeEzeqV5Zum6te6UYrFc1vaNR/De9D4FMDgLLoqngDLHSSqfkuHkSV3ympqqlunRbndeLy4sjpG/5jN1rLayz0a4kUCeL9B2BTTP7/v/gIERAISFhoeELoiLjCeMj4YjkJOJHpSTkpeLjpqIK52RgqKjpKUjAoECqqp+q66oea+vdrKyRrW2Qbi5O7u8OL6uusGsw8Fzx7S4fMt9sxEJACH5BAUAAAQALDsAGQAkAD8AAAOtSLrcziO+SV+8o2qL8f5d+GmhOHJldzZpuS6t+RKxOtO1dCv5DrU+VirokBGFmaNyyWw6n8yAdEqtSl/WrPak7VJH3vB1Iw6Dy1ku2rpaf6HwuHzuBMQBePwzz7cz+31LgIBHg4REhoc+iYo7jHyIj3oTApUCGpJ+DZaWG48PnJ2ehg6hoqONCqanqJOlq02rlbGyTLKXtrW5prSwu6G9vL/Aw6xHusW4yU/EOwkAIfkEBQAABAAsLgAtADEAMQAAA7lIutz+ZMhJq4Q4L8u7/k0nUmA5nlepoaf6sZ67wpb80pOt73zv/8CgcLgLEGWBZPIIUjqNTMzzGX1Mp1XGFZtVbLnZL7gqdnYJZWUPwAZo0lBbu/0p7+b0+laHz+vHCwKCgw59fn9LD4OEhYZCi4uNjkCQjA2GbJSVAg+Ybj+bnJ2YoJsYpD6hp6g8qqt9qaavsK2ys3i1lR+sNq4ZvDK+v7Q6wreZO8a3PcpdzVnP0JBnitPU1dcOCQAh+QQFAAAEACwaADoAPwAkAAADyEi63P4wkiGrvXhojbu3W0h9ZCmKZZqdqOo+7PnOTCzTs33jrh7yL99GIigKXIFkoCIcOYzGlFIJ0j2g0dKUWmVdsUXSltttMcBZBmDNdozJZecZ/WC33W8cOtyw2/F5L3tHDn53DW9Jgnt1hgAPiUsqgxCOj5CJk3SVjhGZJZSchp6fH4wRlhKlHaGifqqrFq2uf7CBF6cSqRWxRJu6nby3smAXu8JbrMUWx7ZTHlgYzc6SQIXB1jPT2Snb3CWj39qv4jRr5QwJACH5BAUAAAQALAsAOgA/ACQAAAPHSLrcJC7KSesUGNvNu8og5I3kE4Jlap2n6kZs+86xPKu1fZc5uuM9zS8VFE0ASIBrwBxccpZkMtVsSmob6bRUtTpiHO3W0/V+fVkx0hFoux1l80ytZLvbkbjzRq8z7ndwenN0EYBvgnEvfYaHAXmDKoyNhxJ6eyWFEo6PloqZmpSAE5egYhScFJEek5uOqqtpahWpsJ+yWha1tl0doRO7pLdRp7qvFsMVs8aVyGWsUhzBvJhDDdPWKtjZJdvcJM3fL+Hi450qCQAh+QQFAAAEACwFAC0AMQAxAAADukgq3P5MyUmrlTDryzvRoOONU2hG5HiaKblurfpCsTs3da7vfO//wKBwCAQQa4Bk8jhSOo1My/MZpUynVckVW91ymd7vMezMkpXmsyfADvDIo3Z75yXJ57pt6o7PUfd8bBUDhIVDgW6DhYRCiIkTi4tAjhaRhj+UipaYiBeWjD6dnp+hopWkPaanmzyZo6w6rq+RrYEjnwO1fLeosbu8sDm2wLS6giS4WavFypC9zQrJ0M6S09SX1s4SCQAh+QQFAAAEACwFABkAJAA/AAADrki6Ks4wytmcpRjb/bJfXPh5oThSZXlOqbpGrfmC8TZD9XUz+Q63vp8riOMQUZ2jcslsOp8MgHRKrUpf1qz2pO1SR97w1SMOg8tZLtq6Wn+h8Lh8Tj8F4oF83qnv35V+fkeBgUSEhTuHiDOKiy+NfT6QepKTGQOYAxOQHpmZEoofnp8RhyOjpBCCp6iYTK2aS7CxR7OvsLK4uai3rb2jv8BKtrvCxZ5Nvsm8TsYRCQAh+QQFAAAEACwFAAoAJAA/AAADrki63K4ivklnvKJqi+X+S3eBoOiRmnmilMqm7tvG8kPXjZrhzs1Dvl+Qp6MAjqii48gEkILN6AcalcIwj2p1g81qt7yv9icG18pWHJr5I6zbijI8/p0vzHa6M8/v+/+AGgGDhIWGgyyHioski46FII+SiBuTkpGWio2ZhyickIGhoqOkogOAA6mpfKqtp3Curm2xsT+0tTW3uC+6uyy9rTjAqsLDtr2wt3bKebI/CQA7"
    }
  })])
}]}

/***/ }),
/* 198 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "homeView"
    }
  }, [_c('div', {
    staticClass: "search-wrapper"
  }, [_c('div', {
    staticClass: "search-head"
  }, [_c('div', {
    staticClass: "prev-btn",
    on: {
      "click": function($event) {
        _vm.prev()
      }
    }
  }, [_c('i', {
    staticClass: "iconfont"
  }, [_vm._v("")])]), _vm._v(" "), _c('div', {
    staticClass: "search-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchVal),
      expression: "searchVal"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    attrs: {
      "type": "input",
      "id": "your-input-id",
      "placeholder": "搜索音乐、歌手、专辑"
    },
    domProps: {
      "value": (_vm.searchVal)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchVal = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.searchVal),
      expression: "searchVal"
    }],
    staticClass: "input-clear closeIcon",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.searchVal = ''
      }
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    ref: "content",
    staticClass: "content",
    staticStyle: {
      "height": "100%",
      "overflow": "hidden"
    }
  }, [_c('scroll', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.logController),
      expression: "!logController"
    }],
    attrs: {
      "data": _vm.songItems,
      "pullup": true
    },
    on: {
      "scrollToEnd": function($event) {
        _vm.songLoadMore()
      }
    }
  }, [_c('ul', {
    staticClass: "search-content"
  }, [(_vm.artist) ? _c('router-link', {
    staticClass: "artist-matching search-list",
    attrs: {
      "tag": "li",
      "to": {
        name: 'artist',
        params: {
          artist: _vm.artist
        }
      }
    }
  }, [_c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.artist.avatar.small,
      "width": "48",
      "height": "48"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "nowrap"
  }, [_c('p', {
    staticClass: "text"
  }, [_vm._v("歌手：" + _vm._s(_vm.artist.name) + "(" + _vm._s(_vm.artist.country) + ")")])])]) : _vm._e(), _vm._v(" "), (_vm.album) ? _c('li', {
    staticClass: "artist-matching search-list"
  }, [_c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.album.pic_small,
      "width": "48",
      "height": "48"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "nowrap"
  }, [_c('p', {
    staticClass: "text"
  }, [_vm._v("专辑：" + _vm._s(_vm.album.title) + "(" + _vm._s(_vm.album.publishcompany) + ")")]), _vm._v(" "), _c('p', [_vm._v("发行时间：" + _vm._s(_vm.album.publishtime))])])]) : _vm._e(), _vm._v(" "), _c('songList', {
    attrs: {
      "styles": 2,
      "songs": _vm.songItems
    }
  }), _vm._v(" "), _c('loading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loadingShow),
      expression: "loadingShow"
    }]
  }), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.noMOre),
      expression: "noMOre"
    }],
    staticStyle: {
      "text-align": "center",
      "margin-top": "20px",
      "font-size": "13px"
    }
  }, [_vm._v("没有更多数据")])], 1)]), _vm._v(" "), _c('scroll', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.logController),
      expression: "logController"
    }],
    ref: "logScroll"
  }, [_c('ul', {
    staticClass: "searchLog search-content"
  }, [_vm._l((_vm.searchLog), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "search-list",
      on: {
        "click": function($event) {
          _vm.searchVal = item
        }
      }
    }, [_vm._v("\n                            " + _vm._s(item) + "\n                            "), _c('span', {
      staticClass: "delete closeIcon",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.logDelete(item)
        }
      }
    }, [_vm._v("×")])])
  }), _vm._v(" "), (!_vm.searchLog.length) ? _c('li', {
    staticStyle: {
      "padding": "20px 0",
      "text-align": "center"
    }
  }, [_vm._v("没有搜索记录")]) : _vm._e()], 2)])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 199 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      night: _vm.night
    },
    attrs: {
      "id": "app"
    }
  }, [_c('home'), _vm._v(" "), _c('Play')], 1)
},staticRenderFns: []}

/***/ }),
/* 200 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('scroll', {
    ref: "scroll",
    attrs: {
      "data": _vm.toplist
    }
  }, [_c('ul', {
    staticClass: "toplist"
  }, _vm._l((_vm.toplist), function(list) {
    return _c('router-link', {
      key: list.path,
      staticClass: "item",
      attrs: {
        "tag": "li",
        "to": {
          path: ("ranking/" + (list.path))
        }
      }
    }, [_c('div', {
      staticClass: "icon"
    }, [_c('img', {
      attrs: {
        "width": "100",
        "height": "100",
        "src": list.icon,
        "alt": "没有图片"
      }
    })]), _vm._v(" "), _c('ul', {
      staticClass: "songlist"
    }, _vm._l((list.item), function(item, index) {
      return _c('li', {
        key: item.album_id
      }, [_c('span', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.title) + "-" + _vm._s(item.artist_name))])])
    }))])
  }))])
},staticRenderFns: []}

/***/ }),
/* 201 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress-wrapper"
  }, [_c('span', {
    staticClass: "timeupdate"
  }, [_vm._v(_vm._s(_vm._f("secToTime")(_vm.timeupdate)))]), _vm._v(" "), _c('div', {
    ref: "barWrapper",
    staticClass: "bar-wrapper"
  }, [_c('div', {
    ref: "bar",
    staticClass: "bar",
    style: ({
      width: (_vm.progress + "%")
    })
  })]), _vm._v(" "), _c('span', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm._f("secToTime")(_vm.time)))])])
},staticRenderFns: []}

/***/ }),
/* 202 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "menu-btn",
    on: {
      "click": function($event) {
        _vm.nightToggle()
      }
    }
  }, [(_vm.nToggle) ? _c('i', {
    staticClass: "iconfont"
  }, [_vm._v("")]) : _c('i', {
    staticClass: "iconfont"
  }, [_vm._v("")])]), _vm._v(" "), _c('ul', {
    staticClass: "header-nav"
  }, _vm._l((_vm.nav), function(navList, key) {
    return _c('router-link', {
      key: key,
      staticClass: "list iconfont",
      attrs: {
        "to": {
          path: navList.path
        },
        "tag": "li"
      },
      domProps: {
        "innerHTML": _vm._s(navList.icon)
      }
    })
  })), _vm._v(" "), _c('router-link', {
    staticClass: "search-btn",
    attrs: {
      "tag": "div",
      "to": {
        path: '/search'
      }
    }
  }, [_c('i', {
    staticClass: "iconfont"
  }, [_vm._v("")])])], 1)
},staticRenderFns: []}

/***/ }),
/* 203 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "opacity"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "lrc-content"
  }, [_c('scroll', {
    ref: "scrolls",
    attrs: {
      "data": _vm.lrc
    }
  }, [_c('ul', {
    staticClass: "lrc-wrapper"
  }, [_vm._l((_vm.lrc), function(value, key, index) {
    return _c('li', {
      key: key,
      class: {
        active: _vm.currentTime === parseInt(key)
      }
    }, [_vm._v(_vm._s(value))])
  }), _vm._v(" "), (!Object.keys(_vm.lrc).length) ? _c('li', [_vm._v("歌词加载中")]) : _vm._e()], 2)])], 1)])
},staticRenderFns: []}

/***/ }),
/* 204 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "songController"
  }, [_c('mode'), _vm._v(" "), _c('div', {
    staticClass: "song-controller"
  }, [_c('div', {
    staticClass: "song-prev",
    on: {
      "click": function($event) {
        _vm.songChange(-1)
      }
    }
  }, [_c('i', {
    staticClass: "iconfont"
  }, [_vm._v("")])]), _vm._v(" "), _c('div', {
    staticClass: "song-play",
    on: {
      "click": function($event) {
        _vm.playGo()
      }
    }
  }, [(!_vm.play) ? _c('i', {
    staticClass: "iconfont"
  }, [_vm._v("")]) : _vm._e(), _vm._v(" "), (_vm.play) ? _c('i', {
    staticClass: "iconfont"
  }, [_vm._v("")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "song-next",
    on: {
      "click": function($event) {
        _vm.songChange(1)
      }
    }
  }, [_c('i', {
    staticClass: "iconfont"
  }, [_vm._v("")])])]), _vm._v(" "), _c('div', {
    staticClass: "song-list-icon",
    on: {
      "click": function($event) {
        _vm.loveFn()
      }
    }
  }, [_c('i', {
    staticClass: "iconfont",
    class: {
      love: _vm.love
    },
    domProps: {
      "innerHTML": _vm._s(_vm.love ? '&#xe669;' : '&#xe66b;')
    }
  })])], 1)
},staticRenderFns: []}

/***/ }),
/* 205 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "top"
    }
  }, [_c('div', {
    staticClass: "toplist-page"
  }, [_c('prevheader', {
    attrs: {
      "title": _vm.title
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.load),
      expression: "load"
    }],
    staticClass: "load"
  }, [_c('loading')], 1), _vm._v(" "), _c('scroll', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.load),
      expression: "!load"
    }],
    attrs: {
      "data": _vm.toplist,
      "pullup": _vm.pullup
    },
    on: {
      "scrollToEnd": function($event) {
        _vm.loadmore()
      }
    }
  }, [_c('ul', {
    staticClass: "list-content"
  }, [_vm._l((_vm.toplist), function(list, index) {
    return _c('li', {
      staticClass: "list",
      on: {
        "click": function($event) {
          _vm.fileLink(list, 1, _vm.toplist)
        }
      }
    }, [_c('div', {
      staticClass: "rank"
    }, [(index <= 2) ? _c('span', {
      class: {
        icon: true, icon1: index === 0, icon2: index === 1, icon3: index === 2
      }
    }) : _c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(index + 1))])]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('h2', {
      staticClass: "name"
    }, [_vm._v(_vm._s(list.title))]), _vm._v(" "), _c('p', {
      staticClass: "desc"
    }, [_vm._v(_vm._s(list.artist_name) + "-" + _vm._s(list.country))])])])
  }), _vm._v(" "), (!_vm.noneData) ? _c('li', [_c('loading')], 1) : _c('li', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "20px",
      "font-size": "13px"
    }
  }, [_vm._v("没有更多数据")])], 2)])], 1)])
},staticRenderFns: []}

/***/ }),
/* 206 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "playList"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.playListToggle),
      expression: "playListToggle"
    }],
    staticClass: "play-list-wrapper"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.playListToggle),
      expression: "playListToggle"
    }],
    staticClass: "playListMask",
    on: {
      "click": function($event) {
        _vm.hide()
      }
    }
  }), _vm._v(" "), _c('div', {
    ref: "playList",
    staticClass: "play-list"
  }, [_c('div', {
    staticClass: "playList-header border-1px"
  }, [_c('mode', {
    attrs: {
      "title": true,
      "size": "22"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clear",
    on: {
      "click": function($event) {
        _vm.clear()
      }
    }
  }, [_c('i', {
    staticClass: "iconfont"
  }, [_vm._v("")]), _vm._v("清空\n                        ")])], 1), _vm._v(" "), _c('scroll', {
    ref: "scroll",
    attrs: {
      "data": _vm.items
    }
  }, [_c('ul', _vm._l((_vm.items), function(item) {
    return _c('li', {
      key: item.song_id,
      staticClass: "list border-1px",
      class: {
        active: _vm.songId === item.song_id
      },
      on: {
        "click": function($event) {
          _vm.fileLink(item)
        }
      }
    }, [(_vm.songId === item.song_id) ? _c('i', {
      staticClass: "iconfont"
    }, [_vm._v("")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "title"
    }, [_vm._v("\n                                    " + _vm._s(item.title || item.songname) + "\n                                ")]), _vm._v("\n                                -\n                                "), _c('span', {
      staticClass: "artistname",
      domProps: {
        "innerHTML": _vm._s(item.author || item.artistname)
      }
    })])
  }))])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 207 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "homeView"
    }
  }, [_c('div', {
    staticClass: "lately-wrapper"
  }, [_c('prevheader', {
    attrs: {
      "title": "最近播放"
    }
  }), _vm._v(" "), _c('scroll', {
    attrs: {
      "data": _vm.items
    }
  }, [_c('div', {
    staticClass: "lately-content"
  }, [(_vm.items.length) ? _c('songlist', {
    attrs: {
      "songs": _vm.items
    }
  }) : _c('p', {
    staticStyle: {
      "padding": "20px"
    }
  }, [_vm._v("暂时没有播放记录")])], 1)])], 1)])
},staticRenderFns: []}

/***/ }),
/* 208 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cd-wrapper",
    class: {
      play: _vm.play, paused: !_vm.play
    }
  }, [_c('div', {
    staticClass: "cd",
    class: {
      rotatePlay: true, rotatePaused: !_vm.play
    }
  }, [_c('div', {
    staticClass: "cd-img"
  }, [_c('img', {
    attrs: {
      "src": _vm.songDetail.pic_radio,
      "alt": ""
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 209 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "controller"
    }
  }, [(_vm.song.title) ? _c('div', {
    staticClass: "play-controller",
    on: {
      "click": function($event) {
        _vm.songShow()
      }
    }
  }, [_c('div', {
    staticClass: "song_info"
  }, [_c('div', {
    staticClass: "song_cover",
    class: {
      rotatePlay: true, rotatePaused: !_vm.playState
    }
  }, [_c('img', {
    attrs: {
      "width": "35",
      "height": "35",
      "src": _vm.song.pic_small ? _vm.song.pic_small : " /static/res/ccnn/0e2442a7d933c8953ee45510d21373f0830200c7.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "song_text"
  }, [_c('h3', {
    staticClass: "song-title"
  }, [_vm._v(_vm._s(_vm.song.title))]), _vm._v(" "), _c('p', {
    staticClass: "singer-name"
  }, [_vm._v(_vm._s(_vm.song.author))])])]), _vm._v(" "), _c('div', {
    staticClass: "play-controller-btn"
  }, [_c('div', {
    staticClass: "play-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.playGo()
      }
    }
  }, [_c('svg', {
    staticClass: "pie",
    class: {
      play: _vm.playState
    },
    attrs: {
      "width": "30",
      "height": "30",
      "viewbox": "0 0 30 30"
    }
  }, [_c('circle', {
    staticClass: "circle-1",
    attrs: {
      "cx": "15",
      "cy": "15",
      "r": "13",
      "stroke-width": "1",
      "stroke": "#D1D3D7",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    ref: "circle",
    staticClass: "circle-2",
    attrs: {
      "cx": "15",
      "cy": "15",
      "r": "13",
      "stroke-width": "1",
      "stroke": "#00A5E0",
      "fill": "none",
      "transform": "matrix(0,-1,1,0,0,30)",
      "stroke-dasharray": _vm.progress
    }
  })]), _vm._v(" "), _c('i', {
    staticClass: "play-icon iconfont",
    class: {
      playIcon: !_vm.playState
    },
    domProps: {
      "innerHTML": _vm._s(_vm.playState ? '&#xe600;' : '&#xe624;')
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "play-list-btn iconfont",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.playList()
      }
    }
  }, [_vm._v("")])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 210 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "song"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "song-wrapper"
  }, [_c('div', {
    staticClass: "bg",
    style: ({
      backgroundImage: ("url(" + (_vm.song.pic_radio) + ")")
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "prev",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.prev()
      }
    }
  }, [_c('i', {
    staticClass: "iconfont"
  }, [_vm._v("")])]), _vm._v(" "), _c('div', {
    staticClass: "song"
  }, [_c('div', {
    staticClass: "song-header"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n            " + _vm._s(_vm.song.title) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "author"
  }, [_vm._v("\n            " + _vm._s(_vm.song.author) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "cdLrc-wrapper",
    class: {
      mask: !_vm.toggle
    },
    on: {
      "click": function($event) {
        _vm.toggleFn()
      }
    }
  }, [_c('transition', {
    attrs: {
      "name": "opacity"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.toggle),
      expression: "toggle"
    }]
  }, [_c('cd', {
    attrs: {
      "play": _vm.playState,
      "songDetail": _vm.song
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "lrc-paragraph"
  }, [_vm._v(_vm._s(this.lrcParagraph))])], 1)]), _vm._v(" "), _c('lrc', {
    attrs: {
      "show": !_vm.toggle,
      "lrc": _vm.lrc.lrcMap,
      "offset": _vm.lrcOffset,
      "currentTime": _vm.currentTime
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "barMargin"
  }, [_c('progressbar')], 1), _vm._v(" "), _c('div', {
    staticClass: "song-controller-wrapper"
  }, [_c('songConteroller', {
    attrs: {
      "song": _vm.song,
      "play": _vm.playState
    }
  })], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 211 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "prev-head",
    class: _vm.opacity
  }, [_c('div', {
    staticClass: "prev-btn",
    on: {
      "click": function($event) {
        _vm.prev()
      }
    }
  }, [_c('i', {
    staticClass: "iconfont"
  }, [_vm._v("")])]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.title))])])
},staticRenderFns: []}

/***/ }),
/* 212 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ranking-wraper"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.load),
      expression: "load"
    }],
    staticClass: "loading-wrapper"
  }, [_c('loading')], 1), _vm._v(" "), _c('toplist', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.load),
      expression: "!load"
    }],
    ref: "toplist",
    on: {
      "loadHide": function($event) {
        _vm.loadHide()
      }
    }
  }), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 213 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "usersuv"
  }, [_c('div', {
    staticClass: "usersuv-list",
    on: {
      "click": function($event) {
        _vm.latelyShow()
      }
    }
  }, [_c('i', {
    staticClass: "iconfont"
  }, [_vm._v("")]), _vm._v(" "), _c('router-link', {
    staticClass: "content border-1px",
    attrs: {
      "tag": "div",
      "to": {
        path: '/lately'
      }
    }
  }, [_c('h3', {
    staticClass: "list-title"
  }, [_vm._v("最近播放")]), _vm._v(" "), _c('span', {
    staticClass: "number"
  }, [_vm._v("(" + _vm._s(_vm.latelyLength ? _vm.latelyLength : 0) + ")")])])], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "usersuv-list off"
  }, [_c('i', {
    staticClass: "iconfont"
  }, [_vm._v("")]), _vm._v(" "), _c('div', {
    staticClass: "content border-1px"
  }, [_c('h3', {
    staticClass: "list-title"
  }, [_vm._v("下载管理")]), _vm._v(" "), _c('span', {
    staticClass: "number"
  }, [_vm._v("(6)")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "usersuv-list off"
  }, [_c('i', {
    staticClass: "iconfont"
  }, [_vm._v("")]), _vm._v(" "), _c('div', {
    staticClass: "content border-1px"
  }, [_c('h3', {
    staticClass: "list-title"
  }, [_vm._v("我的歌手")]), _vm._v(" "), _c('span', {
    staticClass: "number"
  }, [_vm._v("(2)")])])])
}]}

/***/ }),
/* 214 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sheet"
  }, _vm._l((_vm.sheet), function(sheetItem) {
    return _c('dl', {
      staticClass: "sheet-item"
    }, [_c('dt', {
      staticClass: "sheet-title",
      on: {
        "click": function($event) {
          _vm.eventShow(sheetItem)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont",
      class: {
        on: sheetItem.show
      }
    }, [_vm._v("")]), _vm._v("\n            " + _vm._s(sheetItem.title)), _c('span', [_vm._v("(" + _vm._s(sheetItem.length) + ")")])]), _vm._v(" "), _c('dd', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (sheetItem.show),
        expression: "sheetItem.show"
      }],
      staticClass: "item-content"
    }, [(sheetItem.items.length) ? _c('songlist', {
      attrs: {
        "songs": sheetItem.items
      }
    }) : _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!sheetItem.loading),
        expression: "!sheetItem.loading"
      }],
      staticStyle: {
        "font-size": "13px",
        "line-height": "35px",
        "padding": "0 15px"
      }
    }, [_vm._v("还没有喜欢的歌手或歌曲，赶紧去收藏吧！")]), _vm._v(" "), (sheetItem.loading) ? _c('loading') : _vm._e()], 1)])
  }))
},staticRenderFns: []}

/***/ }),
/* 215 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "play-wrapper"
  }, [_c('audio', {
    ref: "audio",
    attrs: {
      "id": "audio",
      "src": _vm.song.file_link
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 216 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "homeView"
    }
  }, [(_vm.artist) ? _c('div', {
    staticClass: "artist"
  }, [_c('prevheader', {
    attrs: {
      "title": _vm.artist.name,
      "styleOpacity": "Opacity"
    }
  }), _vm._v(" "), _c('div', {
    ref: "headerBg",
    staticClass: "prev-headerBg"
  }), _vm._v(" "), _c('div', {
    ref: "avatar",
    staticClass: "avatar"
  }, [_c('img', {
    attrs: {
      "src": _vm.artist.avatar.big,
      "alt": ""
    }
  })]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.nav),
      expression: "!nav"
    }],
    staticClass: "title-nav title-nav-fixed"
  }, [_c('li', {
    staticClass: "list",
    class: {
      on: _vm.type === _vm.hto
    },
    on: {
      "click": function($event) {
        _vm.switchTab(_vm.hto)
      }
    }
  }, [_vm._v("热门50")]), _vm._v(" "), _c('li', {
    staticClass: "list",
    class: {
      on: _vm.type === _vm.singerInfo
    },
    on: {
      "click": function($event) {
        _vm.switchTab(_vm.singerInfo)
      }
    }
  }, [_vm._v("歌手信息")]), _vm._v(" "), _c('li', {
    staticClass: "list",
    class: {
      on: _vm.type === _vm.album
    },
    on: {
      "click": function($event) {
        _vm.switchTab(_vm.album)
      }
    }
  }, [_vm._v("专辑")])]), _vm._v(" "), _c('div', {
    staticClass: "bg"
  }, [_c('scroll', {
    ref: "scroll",
    attrs: {
      "probeType": _vm.probeType,
      "listenScroll": true
    },
    on: {
      "scroll": _vm.__scroll
    }
  }, [_c('div', {
    staticClass: "artils-content"
  }, [_c('div', {
    ref: "operation",
    staticClass: "operation"
  }, [_c('span', {
    staticClass: "item",
    on: {
      "click": function($event) {
        _vm.collection(_vm.artist)
      }
    }
  }, [_vm._v(_vm._s(_vm.collectionSwitch ? '已收藏' : '收藏'))])]), _vm._v(" "), _c('ul', {
    staticClass: "title-nav"
  }, [_c('li', {
    staticClass: "list",
    class: {
      on: _vm.type === _vm.hto
    },
    on: {
      "click": function($event) {
        _vm.switchTab(_vm.hto)
      }
    }
  }, [_vm._v("热门50")]), _vm._v(" "), _c('li', {
    staticClass: "list",
    class: {
      on: _vm.type === _vm.singerInfo
    },
    on: {
      "click": function($event) {
        _vm.switchTab(_vm.singerInfo)
      }
    }
  }, [_vm._v("歌手信息")]), _vm._v(" "), _c('li', {
    staticClass: "list",
    class: {
      on: _vm.type === _vm.album
    },
    on: {
      "click": function($event) {
        _vm.switchTab(_vm.album)
      }
    }
  }, [_vm._v("专辑")])]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type === 1),
      expression: "type === 1"
    }],
    staticClass: "notSong search-content"
  }, [_c('songList', {
    attrs: {
      "styles": 3,
      "songs": _vm.notSong
    }
  }), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.notSong.length),
      expression: "!notSong.length"
    }]
  }, [_c('loading')], 1)], 1), _vm._v(" "), _c('dl', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type === _vm.singerInfo),
      expression: "type === singerInfo"
    }],
    staticClass: "avatarDetail"
  }, [_c('dt', [_vm._v("歌手简介")]), _vm._v(" "), (_vm.avatarDetail) ? _c('dd', _vm._l((_vm.avatarDetail), function(item, index) {
    return _c('p', {
      key: index
    }, [_vm._v(_vm._s(item))])
  })) : _vm._e(), _vm._v(" "), _c('dd', [_c('loading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.avatarDetail),
      expression: "!avatarDetail"
    }]
  })], 1)])])])], 1)], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[65]);


// WEBPACK FOOTER //
// static/js/app.476ddd2364704af5e960.js